/**
 * Keys that the BE *rejects* on the invoice order request DTO (per
 * `FEATURE_B2B_ORDER_PLACEMENT.md` §7). Shipping intent lives on
 * `shipments[]` instead. Kept as a typed const so call sites get an
 * autocomplete'd list and the strip helper stays in sync with the spec.
 */
export const ROOT_SHIPPING_KEYS = [
  'shippingProvider',
  'shippingId',
  'shippingInfo',
  'shippingAddress'
] as const

type RootShippingKey = (typeof ROOT_SHIPPING_KEYS)[number]

/**
 * Return a copy of the payload without the root-level shipping fields.
 * Used before attaching `shipments[0]` to a `CreateInvoiceOrderDTO` /
 * `UpdateInvoiceOrderDTO` payload.
 */
const rootShippingKeySet: ReadonlySet<string> = new Set(ROOT_SHIPPING_KEYS)

export const stripRootShipping = <T extends object>(payload: T): Omit<T, RootShippingKey> => {
  const next: Record<string, unknown> = {}
  Object.entries(payload).forEach(([key, value]) => {
    if (!rootShippingKeySet.has(key)) next[key] = value
  })
  return next as Omit<T, RootShippingKey>
}
